module.exports = __webpack_public_path__ + "static/media/mapping1.430c7669.JPG";